import Vue from 'vue'
import VueRouter from 'vue-router'
import VueSocketIO from 'vue-socket.io'
import VueResource from "vue-resource"
import Repository from "./repositories/Repository"
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vuetify from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'
import moment from 'moment'
import prettyBytes from 'pretty-bytes'
import VueAnalytics from 'vue-analytics'
import VueParticles from 'vue-particles'

// Import App
import App from './App.vue'

// Use generic converters
Vue.prototype.$moment = moment;
Vue.prototype.$prettyBytes = prettyBytes;

// Repositories
import LocalRepository from "@/repositories/LocalRepository";
import AuthRepository from "@/repositories/AuthRepository";

// Views
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Profile from '@/views/Profile.vue'
import Transactions from '@/views/Transactions.vue'
import Viewer from '@/views/Viewer.vue'
import Error from '@/views/Error.vue'
import Tracker from '@/views/Tracker.vue'
import Rates from '@/views/Rates.vue'
import VerifyAccount from '@/views/VerifyAccount.vue'
import RecoverPassword from '@/views/RecoverPassword.vue'
import Referral from '@/views/Referral.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoins } from '@fortawesome/free-solid-svg-icons'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueCarousel from 'vue-carousel';

import Rhino from '@/views/Rhino.vue'
import Documentation from '@/views/Documentation.vue'
import About from '@/views/About.vue'
import Privacy from '@/views/Privacy.vue'
import TermsConditions from '@/views/TermsConditions.vue'
import Support from '@/views/Support.vue'

// Layouts
import DefaultLayout from "@/layouts/DefaultLayout"
import ImageLayout from "@/layouts/ImageLayout"
import MainLayout from "@/layouts/MainLayout"
const LAYOUT_PATH = "/";

library.add(faCoins);
library.add(faTrash);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(VueParticles);
Vue.use(Vuetify, {
    iconfont:'md',
    directives: {
        Ripple
    },
    theme: {
        primary: '#CD5360'
    }
});

let globalData = new Vue({
    data: { $user: null }
});
Vue.mixin({
    computed: {
        $user: {
            get: function () { return globalData.$data.$user },
            set: function (newUser) { globalData.$data.$user = newUser; }
        }
    }
});

import i18n from '@/locales/i18n';

// Vuetify Global CSS
import 'vuetify/dist/vuetify.min.css'

// Open new socket connection
Vue.use(new VueSocketIO({debug: false, connection: Repository.getBaseUrl(), options: {path: Repository.getSocketPath()}}));

const routes = [
    {
        /**
         * Public Zone
         */
        path: LAYOUT_PATH,
        component: MainLayout,
        children: [
            { path: '/', name: 'root', beforeEnter: (to, from, next) => { next({name: 'home', replace: true}); }},
            {
                path: LAYOUT_PATH,
                component: ImageLayout,
                children: [
                    { path: '/home', name: 'home', component: Home },
                    { path: '/home/:token', name: 'home-token', component: Home },
                    { path: '/rates', name: 'rates', component: Rates },
                    { path: '/verify-account/:token', name: 'verify-account', component: VerifyAccount },
                    { path: '/recover-password/:recoverPasswordToken/:securityToken', name: 'recover-password', component: RecoverPassword},
                    { path: '/referral', name: 'referral', component: Referral},
                    { path: '/rhino', name: 'rhino', component: Rhino },
                    { path: '/documentation', name: 'documentation', component: Documentation },
                    { path: '/about', name: 'about', component: About },
                    { path: '/privacy', name: 'privacy', component: Privacy },
                    { path: '/terms', name: 'terms', component: TermsConditions },
                    { path: '/support', name: 'support', component: Support },
                ]
            },
            {
                path: LAYOUT_PATH,
                component: DefaultLayout,
                children: [
                    { path: '/login', name: 'login', component: Login },
                    { path: '/viewer/:hash/:token', name: 'viewer', component: Viewer },
                    { path: '/tracker/:hash/:token', name: 'tracker', component: Tracker},
                    { path: '/error', name: 'error', component: Error,  props: {message:""} },
                ]
            }
        ]
    }, {
        /**
         * Authorized Zone
         */
        path: LAYOUT_PATH,
        component: MainLayout,
        meta: {
            auth: true,
        },
        children: [
            {
                path: LAYOUT_PATH,
                component: DefaultLayout,
                children: [
                    { path: '/profile', name: 'profile', component: Profile },
                    { path: '/tracker/:hash', name: 'tracker-logged', component: Tracker },
                    { path: '/viewer/:hash', name: 'viewer-logged', component: Viewer },
                ]
            },{
                path: LAYOUT_PATH,
                component: ImageLayout,
                children: [
                    { path: '/transactions', name: 'transactions', component: Transactions }
                ]
            }
        ]
    }
];

const router = new VueRouter({routes});

// Configure roles
router.beforeEach((to, from ,next) => {

    // If no matches go to home
    if (!to || to.matched.length === 0) {
        return next({name: "root", replace: true})
    }

    // Check for the meta tags
    let role = null;
    let auth = null;
    for (let match of to.matched) {
        if (match.meta.hasOwnProperty("role")) {
            role = match.meta.role;
        }
        if (match.meta.hasOwnProperty("auth")) {
            auth = match.meta.auth;
        }
    }
    // If we define a role, the user must be authenticated
    if (role) {
        auth = true;
    }

    // Get the user from server
    AuthRepository.getMe()
        .then(user => {
            if (user) {
                // We are logged in
                globalData.$data.$user = user;
                if (auth === false || (role && user.role !== role)) {
                    return next({name: 'root', replace: true});
                }
            } else {
                // We are not logged in
                LocalRepository.clear("token");
                if (auth) {
                    // Open Login Drawer page
                    return next({name: 'login', params: {openLogin: true, next: {path: to.path}}, replace: true});
                }
            }

            // All ok, proceed
            next();

        })

});

Vue.use(VueAnalytics, {
    id: 'UA-137565989-1',
    router
});
Vue.use(VueCarousel);

new Vue({
    router,
    i18n: i18n.data,
    render: h => h(App),
}).$mount('#app');
